var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1047 29.4142C52.3554 28.6649 51.1449 28.6649 50.3956 29.4142L41 38.7905L31.6045 29.395C30.8552 28.6457 29.6447 28.6457 28.8954 29.395C28.146 30.1443 28.146 31.3548 28.8954 32.1042L38.2909 41.4997L28.8954 50.8952C28.146 51.6445 28.146 52.855 28.8954 53.6043C29.6447 54.3537 30.8552 54.3537 31.6045 53.6043L41 44.2088L50.3956 53.6043C51.1449 54.3537 52.3554 54.3537 53.1047 53.6043C53.854 52.855 53.854 51.6445 53.1047 50.8952L43.7092 41.4997L53.1047 32.1042C53.8348 31.374 53.8348 30.1443 53.1047 29.4142Z",
    fill: "#EC5B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0.5C17.9086 0.5 0 18.4086 0 40.5C0 62.5914 17.9086 80.5 40 80.5C62.0914 80.5 80 62.5914 80 40.5C80 18.4086 62.0914 0.5 40 0.5ZM40 4.82432C59.7031 4.82432 75.6757 20.7969 75.6757 40.5C75.6757 60.2031 59.7031 76.1757 40 76.1757C20.2969 76.1757 4.32432 60.2031 4.32432 40.5C4.32432 20.7969 20.2969 4.82432 40 4.82432Z",
    fill: "#E5E5EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0.5C17.9086 0.5 0 18.4086 0 40.5C0 62.5914 17.9086 80.5 40 80.5C62.0914 80.5 80 62.5914 80 40.5C80 18.4086 62.0914 0.5 40 0.5ZM40 4.82432C59.7031 4.82432 75.6757 20.7969 75.6757 40.5C75.6757 60.2031 59.7031 76.1757 40 76.1757C20.2969 76.1757 4.32432 60.2031 4.32432 40.5C4.32432 20.7969 20.2969 4.82432 40 4.82432Z",
    fill: "#EC5B62"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.9177de71f58f20bb20bc78bf11b7cad5.svg";
export { ForwardRef as ReactComponent };